<template>
  <cTable
    :fields="fields"
    :methods="methods"
    :modals="modals"
    :config="config"
    :header="header"
    :footer="footer"
  >
    <template #FLOW> add </template>
  </cTable>
</template>

<script>
import { getList, getUser } from "@/api/reimburse/reimburseStatement";
import cTable from "@/base/common/index";
import { getDepartment } from "@/api/system/department";
import { getWarehouse } from "@/api/storage/warehouse";
import { getList as subject } from "@/api/reimburse/suject.js";
export default {
  name: "reimburseStatement",
  components: {
    cTable,
  },
  async mounted() {
    this.userList = (await getUser()).data.payload;

    this.header.searchs.forEach(async (t) => {
      if (t.key == "user_id") {
        t.options = this.userList;
      }
      if (t.key == "type_id") {
        t.options = this.typeList;
      }
      if (t.key == "currency_type") {
        t.options = this.currencyTypeList;
      }
      if (t.key === "warehouse_id")
        t.options = (await getWarehouse()).data.payload.rows;
      if (t.key === "subject")
        t.options = (await subject()).data.payload.map((t) => {
          return {
            label: this.$i18n.locale === "zh-CN" ? t.name : t.name_eng,
            value: t.id,
          };
        });
    });
  },
  data() {
    let that = this;
    return {
      userList: [],
      typeList: [
        {
          label: this.$t("personal"),
          value: 1,
        },
        {
          label: this.$t("assistDepartment"),
          value: 2,
        },
      ],
      currencyTypeList: [
        {
          label: this.$t("cash"),
          value: 1,
        },
        {
          label: this.$t("bank deposit"),
          value: 2,
        },
      ],
      methods: {
        list: getList,
      },
      config: {
        height: 630,
        showOverflow: false,
      },
      footer: {
        show: () => false,
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
          },
          {
            key: "user_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("user_name");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "subject",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("reimburseSuject");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
          },
          // {
          // 	key:'type_id',
          // 	component:'Select',
          // 	placeholder:()=>this.$t("reimburse")+this.$t('type'),
          // 	options:this.typeList,
          // },
          {
            key: "currency_type",
            component: "Select",
            placeholder: () => this.$t("fee_type"),
            options: this.currencyTypeList,
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export({ searchForm }) {
              this.handleRequestMethods("list", {
                ...searchForm,
                export: 1,
                ids: this.selectAll.map((t) => t.id),
              }).then(
                (res) => {
                  window.open(this.$globalUrl + res.payload.src);
                },
                true,
                true
              );
              // this.exportExc();
            },
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$t("add"));
              });
            },
          },
        },
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              this.$page
                .handleRequestMethods(
                  row.id ? "update" : "add",
                  row,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
              disabled() {
                return this.formData.preview;
              },
            },
            rules: {
              type_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ type_id: 24 }, { department_id: 24 }],
          fields: [
            {
              key: "type_id",
              name: this.$t("type"),
              component: "Select",
              placeholder: this.$t("type"),
              options: [
                {
                  label: "个人",
                  value: "1",
                },
                {
                  label: "部门",
                  value: "2",
                },
              ],
            },
            {
              key: "department_id",
              name: () => this.$t("deName"),
              component: "SelectTree",
              config: {
                label: "title",
                value: "id",
              },
              placeholder() {
                return this.$t("select") + this.$t("deName");
              },
              options: [],
              trees: [],
              methods: {
                async list({ field }) {
                  let trees = (
                    await this.$page.handleRequestMethods("getDepartment")
                  ).payload.rows;
                  this.handleTree({ field, trees });
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
      },

      fields: [
        {
          name: () => this.$t("Reimbursement slip number"),
          key: "serial_number",
          minWidth: 130,
        },
        {
          key: "warehouse_name",
          name: this.$t("warehouseName"),
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Reimbursement type"),
          key: "type_name",
          minWidth: 130,
          bind: {
            style({ row }) {
              return {
                color: row.color,
              };
            },
          },
        },
        {
          name: () => this.$t("Cost details"),
          key: "title",
          minWidth: 130,
        },
        {
          name: () => this.$t("Reasons for reimbursement"),
          key: "reason",
          minWidth: 130,
        },
        {
          name: () => this.$t("fee_type"),
          key: "currency_type",
          minWidth: 130,
        },
        {
          name: () => this.$t("applyAmount"),
          key: "amount",
          minWidth: 130,
        },
        {
          name: () => this.$tz("余额"),
          key: "balance",
          minWidth: 130,
        },
        {
          name: () => this.$t("Currency of application"),
          key: "currency",
          minWidth: 130,
        },
        {
          name: () => this.$t("proposer"),
          key: "create_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("Application_time"),
          key: "create_time",
          minWidth: 130,
        },
        {
          type: "btns",
          width: 80,
          name: () => this.$t("operation"),
          list: [
            // {
            //   name: () => this.$t("update"),
            //   type: "edit",
            //   fnName: "edit",
            //   bind: {
            //     type: "primary",
            //   },
            // },
          ],
          methods: {
            edit({ row }) {
              row.type_id += "";
              this.getModal("add").open(row, function () {
                this.setTitle(this.$t("add"));
              });
            },
          },
        },
      ],
    };
  },
};
</script>
